import { graphql } from '@mp/graphql/generated';
import { useGraphQLQuery } from '@mp/hooks/useGraphQLRequest';
import { type ResultOf } from '@graphql-typed-document-node/core';

const OrientationJobsGql = graphql(`
  query GetOrientationJobs($input: JobQueryInput) {
    availableJobs(input: $input) {
      id
      positions {
        display_name
      }
      ...OrientationJobsListItemJob
    }
  }
`);

export const useOrientationJobsList = (poolId: number) => {
  const { data, isLoading } = useGraphQLQuery<ResultOf<typeof OrientationJobsGql>>({
    operationName: 'GetJobsForOrientationJobsList',
    queryKey: ['GetJobsForOrientationJobsList', poolId],
    query: OrientationJobsGql,
    variables: {
      input: {
        search: {
          pool_id: poolId,
          kind: 'orientation',
          status: 'active',
        },
        orderBy: {
          starts_time: true,
        },
      },
    },
  });

  return {
    jobs: data?.availableJobs || [],
    isLoading,
  };
};
